import './FacebookLogin.css';
import FacebookLogin from './FacebookLogin';

export default FacebookLogin;


// WEBPACK FOOTER //
// ./src/components/FacebookLogin/index.js